import { useCallback, useState } from 'react';
import classNames from 'classnames';
import { generateVariableSymbol } from '@amf/shared/utils/string';

import ReprePromoteForm, { ReprePromoteData } from './ReprePromoteForm';
import ReprePromotePayment from './ReprePromotePayment';

export type PromoteDataWithVariableSymbol = ReprePromoteData & {
  variableSymbol: string;
};

type Props = {
  className?: string;
};

function ReprePromote({ className }: Props) {
  const [data, setData] = useState<PromoteDataWithVariableSymbol | null>(null);
  const [error, setError] = useState<string | null>(null);

  const send = useCallback(async (data: ReprePromoteData) => {
    const variableSymbol = generateVariableSymbol();
    const response = await fetch('/api/repre-promo-order', {
      body: JSON.stringify({ ...data, variableSymbol }),
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
    });

    const result = (await response.json()) as {
      success?: boolean;
      error?: string;
    };

    if (result.error) {
      console.log(result.error);
      setError(result.error);
      return;
    }

    if (result.success) {
      setData({ ...data, variableSymbol });
    }
  }, []);

  return (
    <div className={classNames('ReprePromote', className)}>
      {error && <div className='ReprePromote__error'>{error}</div>}
      {data ? <ReprePromotePayment data={data} /> : <ReprePromoteForm onSubmit={send} />}
    </div>
  );
}

export default ReprePromote;
